export const LOCATION_REGION_MAP = [
  { prefixes: ['Delhi', 'Jaipur'], region: 'North' },
  { prefixes: ['Bengaluru', 'Bangalore', 'Chennai', 'Hyderabad'], region: 'South' },
  { prefixes: ['Kolkata'], region: 'East' },
  { prefixes: ['Ahmedabad', 'Mumbai', 'Pune'], region: 'West' },
  { prefixes: ['Lucknow'], region: 'Central' },
];

export const deriveRegionFromLocation = (location, locationRegionMap = {}, knownRegions = []) => {
  if (!location) return null;
  const loc = String(location).toLowerCase();

  if (locationRegionMap && typeof locationRegionMap === 'object') {
    const exact = locationRegionMap[location] || locationRegionMap[String(location).trim()];
    if (exact) {
      return String(exact).trim();
    }

    for (const [candidateLocation, region] of Object.entries(locationRegionMap)) {
      const candidate = String(candidateLocation || '').toLowerCase();
      if (!candidate) continue;
      if (loc === candidate || loc.includes(candidate)) {
        return String(region || '').trim() || null;
      }
    }
  }

  if (Array.isArray(knownRegions) && knownRegions.length > 0) {
    for (const region of knownRegions) {
      const needle = String(region || '').toLowerCase().trim();
      if (needle && (loc === needle || loc.includes(needle))) {
        return String(region).trim();
      }
    }
  }

  for (const entry of LOCATION_REGION_MAP) {
    for (const prefix of entry.prefixes) {
      const needle = prefix.toLowerCase();
      if (loc.startsWith(needle) || loc.includes(needle)) return entry.region;
    }
  }
  return null;
};

export const deriveGranularityFromRegion = (region) => {
  const value = String(region || '').trim().toLowerCase();
  if (!value) return 'daily';
  return 'daily';
};

export const deriveGranularityFromLocation = (location) => {
  const region = deriveRegionFromLocation(location);
  return deriveGranularityFromRegion(region);
};
